import React, { ChangeEvent, FC, useState } from 'react'
import { Promotion } from '../../@types/prefix'
import { Button, Form, Input, Select } from 'antd'
import { RedoOutlined } from '@ant-design/icons';
// import { getDomainWithoutSubdomain } from '../../utils/domainWithoutSubdomain'
import Turnstile from "react-turnstile";

interface RegisterStep3Props {
	knowFrom: string
	defaultAffiliateCode: string
	promotions: Promotion[]
	isSubmitting: boolean
	recaptcha: any

	setKnowFrom: (e: any) => void
	handleSubmit: (e: ChangeEvent<any>) => void
	setTurnstile: (e: any) => void
}

const RegisterStep3: FC<RegisterStep3Props> = ({
	knowFrom,
	defaultAffiliateCode,
	promotions,
	isSubmitting,
	recaptcha,

	setKnowFrom,
	handleSubmit,
	setTurnstile
}) => {
	const prefixKey = localStorage.getItem('x-prefix')
	const [captchaT, setCaptchaT] = useState(Date.now())

	const captchaURL = `${process.env.REACT_APP_API_ENDPOINT}/register/captcha?prefix=${prefixKey}&t=${captchaT}`
	// const captchaURL = `https://api.${getDomainWithoutSubdomain(window.location.host)}/v2/register/captcha?prefix=${prefixKey}&t=${captchaT}`

	// let captchaURL = `${process.env.REACT_APP_API_ENDPOINT}/register/captcha?prefix=${prefixKey}&t=${captchaT}`
	// if (window.location.hostname !== 'localhost' &&
	// 	window.location.hostname !== "msn.bet" &&
	// 	window.location.hostname !== "msn1.bet" &&
	// 	window.location.hostname !== "msn2.bet") {
	// 	captchaURL = `https://api.${getDomainWithoutSubdomain(window.location.host)}/v2/register/captcha?prefix=${prefixKey}&t=${captchaT}`
	// }

	const affiliateReadOnly = defaultAffiliateCode ? true : false

	return (
		<>
			<Form.Item
				name="password"
				label="รหัสผ่าน"
				rules={[{ required: true, message: 'กรุณากรอกรหัสผ่าน' }]}
				hasFeedback>
				<Input.Password placeholder="รหัสผ่าน" inputMode='text' />
			</Form.Item>
			<Form.Item
				name="line"
				label="ไอดีไลน์"
				rules={[{ required: true, message: 'กรุณากรอกไอดีไลน์' }]}
				hasFeedback>
				<Input placeholder="ไอดีไลน์" inputMode='text' />
			</Form.Item>
			<Form.Item
				name="autoBonus"
				label="รับโบนัสอัตโนมัติ"
				rules={[{ required: true, message: 'กรุณาเลือกรับโบนัสอัตโนมัติ' }]}
				hasFeedback
				initialValue={"off"}>
				<Select
					placeholder="เลือกรับโบนัสอัตโนมัติ"
					showSearch
					optionFilterProp="children"
					filterOption={(input: any, option: any) =>
						option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
					}>
					<Select.Option value="off">ไม่รับโบนัสอัตโนมัติ</Select.Option>
					{promotions
						.filter((v) => v.amount > 0)
						.map((promotion) => (
							<Select.Option value={promotion.key} key={promotion.key}>
								{promotion.name}
							</Select.Option>
						))}
				</Select>
			</Form.Item>
			{!defaultAffiliateCode && (
				<Form.Item
					name="knowFrom"
					label="ช่องทางที่รู้จักเรา"
					rules={[{ required: true, message: 'กรุณาเลือกช่องทางที่รู้จักเรา' }]}
					hasFeedback>
					<Select
						placeholder="เลือกช่องทางที่รู้จักเรา ..."
						showSearch
						optionFilterProp="children"
						onSelect={setKnowFrom}
						filterOption={(input: any, option: any) =>
							option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}>
						<Select.Option value="facebook" key="facebook">Facebook</Select.Option>
						<Select.Option value="twitter" key="twitter">Twitter</Select.Option>
						<Select.Option value="line" key="line">Line</Select.Option>
						<Select.Option value="google" key="google">Google</Select.Option>
						<Select.Option value="instargram" key="instargram">Instargram</Select.Option>
						<Select.Option value="youtube" key="youtube">Youtube</Select.Option>
						<Select.Option value="tiktok" key="tiktok">Tiktok</Select.Option>
						<Select.Option value="onlyfans" key="onlyfans">Onlyfans</Select.Option>
						<Select.Option value="telegram" key="telegram">Telegram</Select.Option>
						<Select.Option value="vk" key="vk">VK</Select.Option>
						<Select.Option value="friend" key="friend">เพื่อนแนะนำ</Select.Option>
						<Select.Option value="other" key="other">โฆษณาอื่น ๆ</Select.Option>
					</Select>
				</Form.Item>
			)}
			{defaultAffiliateCode && (
				<Form.Item
					name="knowFrom2"
					label="ช่องทางที่รู้จักเรา"
					rules={[{ required: true, message: 'กรุณาเลือกช่องทางที่รู้จักเรา' }]}
					hasFeedback>
					<Select
						placeholder="เลือกช่องทางที่รู้จักเรา ..."
						showSearch
						optionFilterProp="children"
						filterOption={(input: any, option: any) =>
							option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}>
						<Select.Option value="facebook" key="facebook">Facebook</Select.Option>
						<Select.Option value="twitter" key="twitter">Twitter</Select.Option>
						<Select.Option value="line" key="line">Line</Select.Option>
						<Select.Option value="google" key="google">Google</Select.Option>
						<Select.Option value="instargram" key="instargram">Instargram</Select.Option>
						<Select.Option value="youtube" key="youtube">Youtube</Select.Option>
						<Select.Option value="tiktok" key="tiktok">Tiktok</Select.Option>
						<Select.Option value="onlyfans" key="onlyfans">Onlyfans</Select.Option>
						<Select.Option value="telegram" key="telegram">Telegram</Select.Option>
						<Select.Option value="vk" key="vk">VK</Select.Option>
						<Select.Option value="other" key="other">โฆษณาอื่น ๆ</Select.Option>
					</Select>
				</Form.Item>
			)}
			{knowFrom === "friend" && (
				<Form.Item
					name="affiliateCode"
					label="รหัสชวนเพื่อน"
					rules={[{ required: true, message: 'กรุณากรอกรหัสชวนเพื่อน' }]}
					hasFeedback
					initialValue={defaultAffiliateCode}>
					<Input placeholder="รหัสชวนเพื่อน" inputMode='text' readOnly={affiliateReadOnly} />
				</Form.Item>
			)}
			{(window.location.hostname === 'localhost') ? (
				<>
					<div className="captcha-row">
						<img src={captchaURL} alt="Captcha" />
						<Button
							type="link"
							icon={<RedoOutlined />}
							onClick={() => setCaptchaT(Date.now())}>
							ลองรูปอื่น
						</Button>
					</div>
					<Form.Item
						name="captcha"
						label="กรอกรหัสตามภาพ"
						rules={[{ required: true, message: 'กรุณากรอกรหัสตามภาพ' }]}
						hasFeedback>
						<Input placeholder="กรอกรหัสตามภาพ" inputMode='text' />
					</Form.Item>
				</>
			) : (
				recaptcha.enable && (
					<div style={{ marginBottom: "10px" }}>
						<Turnstile
							sitekey={recaptcha.key}
							theme="dark"
							onVerify={(token) => setTurnstile(token)}
						/>
					</div>
				)
			)}
			<Form.Item>
				<Button
					type="primary"
					htmlType="submit"
					shape="round"
					loading={isSubmitting}
					onClick={handleSubmit}
					block
				>
					สมัครสมาชิก
				</Button>
			</Form.Item>

		</>
	)
}

export default RegisterStep3
